import GoalsSerializer from './base';

export default class Subcategory extends GoalsSerializer {}
